import { render, staticRenderFns } from "./TopNavigationBar.vue?vue&type=template&id=bfac7626&scoped=true"
import script from "./TopNavigationBar.vue?vue&type=script&lang=js"
export * from "./TopNavigationBar.vue?vue&type=script&lang=js"
import style0 from "./TopNavigationBar.vue?vue&type=style&index=0&id=bfac7626&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfac7626",
  null
  
)

export default component.exports